/* @flow @format */

import { type ContextRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import React from 'react';
import qs from 'qs';

import { ButtonIcon, Footer, Page, PageContainer, Panel } from '@sonyged/ext-proc';

import type { StoreState } from '../../../redux/types';
import { contest, isReloadNeeded } from '../../../redux/selector';
import AppContext from '../../../AppContext';
import IntroModal from './IntroModal';
import LoadingButton from '../../../components/LoadingButton';
import TitleModal from '../../common/TitleModal';
import api from '../../../graphql/api';

type OwnProps = {|
  ...ContextRouter
|};

type Props = {
  ...OwnProps,
  courseContentUid: ?string,
  reloadNeeded: boolean
};

type State = {|
  introModal: boolean,
  titleModal: boolean
|};

class IceAdvancedFieldPage extends React.Component<Props, State> {
  static contextType = AppContext;

  constructor(props: Props) {
    super(props);

    if (props.reloadNeeded) location.reload();

    this.state = {
      introModal: this._getIntroFromQuery(props),
      titleModal: false
    };
  }

  componentDidMount() {
    this.context.soundController.bgmPlay('proc_field02', true);

    // If browser reload this page or access to this page directly,
    // The parent dom is NOT rendered and the IntroModal try to refer to it and failed.
    // This code assures that the parent dom is rendered once.
    requestAnimationFrame(() => {
      this.forceUpdate();
    });
  }

  render() {
    const { introModal, titleModal } = this.state;
    if (introModal) {
      return <IntroModal onNextClick={this._onNextClick.bind(this)} />;
    }

    if (titleModal) {
      return (
        <div id="proc-ice-fields-root-page" className={'ice'}>
          <TitleModal
            title="フィールド"
            subTitle="アイスクリームを仕入れて売ろう"
            rootNodeId="proc-ice-fields-root-page"
            onNext={this._onTitleNext.bind(this)}
          />
        </div>
      );
    }

    const { courseContentUid } = this.props;

    if (!courseContentUid) throw new Error('Unknown uid');

    return (
      <div
        id="proc-ice-fields-root-page"
        className="ice proc-ice-fields-top-page course-top-page-template tertiary100-bg-color"
      >
        <Page.normal menu={false}>
          <PageContainer.normal>
            <Panel.vertical fullHeight={true}>
              <div className="course-top-page-content">
                <div className="title-container">
                  <div className="sub-title proc-small-font secondary100-color">フィールド</div>
                  <div className="title proc-huge-font gray100-color">アイスクリームを仕入れて売ろう</div>
                </div>
                <div className="secondary20-border-color proc-border" />
                <div className="desc proc-medium-font gray100-color">
                  仕入れたアイスクリームをいろんな場所で売って、もうけたお金をきそうよ。
                </div>
                <div className="links-container">
                  <Link to="/ice-a/fields/rank" className="proc-button proc-button--normal">
                    <span className="icon-proc-ice-ranking">
                      <span className="path1 icon-proc-path" />
                      <span className="path2 icon-proc-path" />
                      <span className="path3 icon-proc-path" />
                      <span className="path4 icon-proc-path" />
                      <span className="path5 icon-proc-path" />
                    </span>
                    ランキング
                  </Link>
                </div>
                <img className="image" src="../../images/pages/ice/img_ice_field@2x.png" />
              </div>
              <Footer.nav
                className={'inner'}
                navItem={
                  <Link to="/ice-a">
                    <LoadingButton.normal>
                      <ButtonIcon.back />
                    </LoadingButton.normal>
                  </Link>
                }
              >
                <LoadingButton.attention
                  className={'next'}
                  onClick={() => {
                    api.checkoutActivity({ courseContentUid }).then(() => {
                      this._onStartClick();
                    });
                  }}
                >
                  はじめる
                </LoadingButton.attention>
              </Footer.nav>
            </Panel.vertical>
          </PageContainer.normal>
        </Page.normal>
      </div>
    );
  }

  _onNextClick() {
    this.setState({ introModal: false });
  }

  _onStartClick() {
    this.setState({ titleModal: true });
  }

  _onTitleNext() {
    this.props.history.push('/ice-a/fields/challenge');
  }

  _getIntroFromQuery(props: Props) {
    const params = qs.parse(props.location.search, { ignoreQueryPrefix: true });
    if (params['skip_intro']) {
      return false;
    }
    return true;
  }
}

const mapStateToProps = (state: StoreState) => ({
  courseContentUid: contest['ice-a'].fieldUid(state),
  reloadNeeded: isReloadNeeded(state)
});

export default connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(IceAdvancedFieldPage);
